require('./index.scss')

import PropTypes from 'prop-types'
import { useState } from 'react'

import Dialog from '@/components/Dialog'
import Message from '@/components/PageLevelMessage/components/Message'
import {
  DIALOG_TYPES,
  PAGE_LEVEL_MESSAGE_TYPES
} from '@/constants/notificationTypes'
import { translate } from '@/utils/translations'

import CloseButton from './components/CloseButton'

const NotificationDialog = ({ message: { text, type } }) => {
  const isErrorDialog = type === DIALOG_TYPES.error
  const translationKey = `common.${isErrorDialog ? 'error' : 'success'}`

  const [isShowing, setisShowing] = useState(true)

  const handleOnClick = () => setisShowing(false)

  const validationType = isErrorDialog
    ? PAGE_LEVEL_MESSAGE_TYPES.error
    : PAGE_LEVEL_MESSAGE_TYPES.success

  return (
    <Dialog
      heading={translate(translationKey)}
      id='notification-dialog'
      isShowing={isShowing}
      onChangeShow={setisShowing}
      validationType={type}
    >
      <Message message={text} type={validationType} />
      <CloseButton onClick={handleOnClick} />
    </Dialog>
  )
}

export default NotificationDialog

NotificationDialog.propTypes = {
  message: PropTypes.shape({
    text: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  }),
  type: PropTypes.oneOf([DIALOG_TYPES.error, DIALOG_TYPES.success])
}
